import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { toast } from 'react-toastify';

const AddUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
    });

    useEffect(() => {
        if (id) {
            getSingleData();
        }
    }, [id]);

    const getSingleData = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: 'GET',
                url: `/admin/expense-categories/${id}`
            });
            if (response.data.status) {
                setFormData(response.data.data);
            } else {
                toast.error(response.data.message);
                navigate('/expense-categories');
            }
        } catch (error) {
            toast.error('Failed to fetch data');
            navigate('/expense-categories');
        } finally {
            setIsLoader(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: id ? 'PUT' : 'POST',
                url: id ? `/admin/expense-categories/${id}` : '/admin/expense-categories',
                data: formData
            });
            if (response.data.status) {
                toast.success(response.data.message);
                navigate('/expense-categories');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Something went wrong');
            if (error.response && error.response.data && error.response.data.errors) {
                // Handle validation errors if needed
            }
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            {id ? 'Edit Expense Category' : 'Add Expense Category'}
                        </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to="/expense-categories" className="btn btn-sm fw-bold btn-secondary">
                            Back
                        </Link>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                        <div className="card-body py-4">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label required">Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control form-control-solid"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        name="description"
                                        className="form-control form-control-solid"
                                        rows="3"
                                        value={formData.description}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>
                                <div className="text-end">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isLoader}
                                    >
                                        {isLoader ? 'Please wait...' : 'Submit'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddUpdate;
